import { GridColDef } from '@mui/x-data-grid-premium';
import TenantPage from 'components/common/TenantPage';
import { dateTimeCell } from 'components/common/enhanced/cells/date-time-cell';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { systemAccessLogService } from 'services/api/SystemAccessLogService';
import { dateFilterOperators } from '../../../constants';

export const SystemAccessLogPage = () => {
  const translationPrefix = 'pages.system_access_logging';
  const { t } = useTranslation();
  const datagridRefresh = useRef(null);

  const columns: GridColDef[] = [
    {
      field: 'happened_at',
      headerName: t(`${translationPrefix}.timestamp`),
      flex: 1,
      filterOperators: dateFilterOperators,
      renderCell: dateTimeCell
    },
    {
      field: 'username',
      headerName: t(`${translationPrefix}.user`),
      flex: 1
    },
    {
      field: 'result',
      headerName: t(`${translationPrefix}.result`),
      flex: 1,
      valueGetter: (params) => (params.row?.result === 'FAILED' ? 'FALLITO' : 'SUCCESSO')
    }
  ];

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <EnhancedDataGrid
        refresh={datagridRefresh}
        service={systemAccessLogService}
        columns={columns}
      />
    </TenantPage>
  );
};

export default SystemAccessLogPage;
